import { httpService } from '../..';
import { IEntityWithMessages } from '../../services/HttpService';
import { IPagedResponse } from '../apiInterfaces';
import { ApiUrls } from '../ApiUrls';
import { ISalesCallFilters } from '../filters';
import { IInfoCallRequest, ISalesCall } from './salesCallInterfaces';

export async function addSalesCall(salesCall: ISalesCall): Promise<IEntityWithMessages<ISalesCall>> {
  try {
    const response = await httpService.post(ApiUrls.salesCalls(), salesCall);
    return await response.json();
  } catch (e) {
    throw e;
  }
}

export async function addInfoCall(salesCall: IInfoCallRequest): Promise<IEntityWithMessages<ISalesCall>> {
  try {
    const response = await httpService.post(ApiUrls.salesCallsInfo(), salesCall);
    return await response.json();
  } catch (e) {
    throw e;
  }
}

export async function deleteSalesCall(salesCallId: number): Promise<number> {
  try {
    await httpService.delete(ApiUrls.salesCall(salesCallId));
    return salesCallId;
  } catch (e) {
    throw e;
  }
}

export async function FetchPagedSalesCalls(
  filters: ISalesCallFilters,
  skip: number,
  lastFetched?: Date
): Promise<IPagedResponse<ISalesCall[]>> {
  try {
    const response = await httpService.get(ApiUrls.salesCallsPaged(filters, skip));
    return await response.json();
  } catch (e) {
    throw e;
  }
}

export async function FetchSalesCalls(
  businessEntityId: number,
  skip: number,
  lastFetched?: Date
): Promise<IPagedResponse<ISalesCall[]>> {
  try {
    const response = await httpService.get(ApiUrls.getBusinessEntitySalesCalls(businessEntityId, skip));
    return await response.json();
  } catch (e) {
    throw e;
  }
}

export async function fetchSalesCallsByDate(payload: {
  date: Date | string;
  salesDistricts: string[];
}): Promise<ISalesCall[]> {
  try {
    const response = await httpService.get(ApiUrls.salesCallsByDate(payload.date, payload.salesDistricts));
    return await response.json();
  } catch (e) {
    throw e;
  }
}

export async function updateSalesCall(salesCall: ISalesCall): Promise<IEntityWithMessages<ISalesCall>> {
  try {
    const response = await httpService.put(ApiUrls.salesCall(salesCall.salesCallId), salesCall);
    return await response.json();
  } catch (e) {
    throw e;
  }
}
